export default function labels(state = {}, action = null) {
	if (!action.error && action.payload !== undefined) {
		switch (action.type) {
			case 'WS_SCRIPTS_ADD_LABELS':
				return {
					...state,
					...action.payload
				};

			// no default
		}
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/ws-scripts/reducers/labels.js